import React from 'react';

/**
 * Renders N shimmer placeholder rows while data is loading.
 * Uses the .skeleton-row CSS animation defined in App.css.
 *
 * @param {number} count - Number of skeleton rows to render (default 5)
 */
export function SkeletonRow({ count = 5 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-row" aria-hidden="true" />
      ))}
    </>
  );
}
